module.exports = __webpack_public_path__ + "e63504521e0a852787223dfcbf420781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.jpg
// module id = 741
// module chunks = 0